<template>
    <v-overlay
        id="MaintenanceOverlay-root"
        :model-value="store.maintenance"
        persistent
        no-click-animation
        scrim="black"
        opacity="0.6"
        class="align-center justify-center"
    >
        <v-card
            id="MaintenanceOverlay-card"
            class="pa-6 text-center mx-auto"
            max-width="420"
            elevation="8"
        >
            <NamedLoader
                id="MaintenanceOverlay-spinner"
                label="Waiting for the update to finish"
                color="primary"
                size="48"
                class="mb-4"
            />
            <div
                id="MaintenanceOverlay-message"
                class="text-h6 mb-2"
            >
                Studoku is updating
            </div>
            <div
                id="MaintenanceOverlay-submessage"
                class="text-body-2 text-medium-emphasis"
            >
                Back in a moment — your work is safe and will still be here.
            </div>
        </v-card>
    </v-overlay>
</template>

<script lang="ts" setup>
import { useAppStore } from '@/shared/store';

import NamedLoader from './NamedLoader.vue';

// Non-destructive: this overlay blocks interaction while a deploy window is in
// progress but never unmounts the app/router/store, so in-progress edits
// survive. The store polls GET /api/config and clears `maintenance` on the
// first healthy response — no reload.
const store = useAppStore();
</script>
